var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtherGames({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1499 0.886432C12.6099 0.34645 11.7345 0.34645 11.1945 0.886431L8.66455 3.41636C8.12456 3.95634 8.12456 4.83182 8.66455 5.3718L11.3245 8.03174C11.8645 8.57172 12.7399 8.57172 13.2799 8.03174L15.8099 5.50182C16.3498 4.96183 16.3498 4.08635 15.8099 3.54637L13.1499 0.886432ZM1.59755 1.0028C0.833904 1.0028 0.214844 1.62186 0.214844 2.38551V6.60109C0.214844 7.36473 0.833902 7.98379 1.59755 7.98379H6.01548C6.77913 7.98379 7.39819 7.36474 7.39819 6.60109V2.38551C7.39819 1.62186 6.77913 1.0028 6.01548 1.0028H1.59755ZM1.59755 8.96181C0.833904 8.96181 0.214844 9.58087 0.214844 10.3445V14.5601C0.214844 15.3237 0.833902 15.9428 1.59755 15.9428H6.01548C6.77913 15.9428 7.39819 15.3237 7.39819 14.5601V10.3445C7.39819 9.58087 6.77913 8.96181 6.01548 8.96181H1.59755ZM8.646 10.3445C8.646 9.58087 9.26506 8.96181 10.0287 8.96181H14.4466C15.2103 8.96181 15.8293 9.58087 15.8293 10.3445V14.5601C15.8293 15.3237 15.2103 15.9428 14.4466 15.9428H10.0287C9.26506 15.9428 8.646 15.3237 8.646 14.5601V10.3445Z",
    fill: "var(--gray-40)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherGames);
export default __webpack_public_path__ + "static/media/other-games.5297d8e0f7fc9547034c28b81c897ca3.svg";
export { ForwardRef as ReactComponent };